export const SESSION_TIMEOUT_STORAGE_KEY = 'sessionTimeoutMinutes';
export const DEFAULT_SESSION_TIMEOUT_MINUTES = 30;
export const MIN_SESSION_TIMEOUT_MINUTES = 5;
export const MAX_SESSION_TIMEOUT_MINUTES = 480; // 8 hours

export const getSessionTimeoutMinutes = () => {
  const stored = localStorage.getItem(SESSION_TIMEOUT_STORAGE_KEY);
  if (stored === null) return DEFAULT_SESSION_TIMEOUT_MINUTES;
  const parsed = parseInt(stored, 10);
  if (isNaN(parsed) || parsed < MIN_SESSION_TIMEOUT_MINUTES || parsed > MAX_SESSION_TIMEOUT_MINUTES) {
    return DEFAULT_SESSION_TIMEOUT_MINUTES;
  }
  return parsed;
};

export const setSessionTimeoutMinutes = (minutes) => {
  const value = Math.max(MIN_SESSION_TIMEOUT_MINUTES, Math.min(MAX_SESSION_TIMEOUT_MINUTES, minutes));
  localStorage.setItem(SESSION_TIMEOUT_STORAGE_KEY, value.toString());
  return value;
};
